export default {
  callingAPI: false,
  searching: '',
  serverURI: 'https://dwalletuat.danamon.co.id',
  user: null,
  token: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: [],
  },
  addData: {},
  new_mcount: 0,
  new_nmidcount: 0,
}



// WEBPACK FOOTER //
// ./src/store/state.js